<div class="w-full bg-sable min-h-screen py-10 px-4">

    <div class="w-4/5 mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-8 md:p-12">

        <div class="bg-uploadBg border-l-4 border-accent p-6 mb-10">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <mat-icon class="text-accent">info</mat-icon>
                </div>
                <div class="ml-4">
                    <h3 class="text-lg font-bold text-black">Commencez votre projet en déposant le devis</h3>
                    <p class="text-sm text-black mt-1">
                        Une fois validé par nos équipes, vous pourrez démarrer les travaux et ajouter tous les autres
                        documents de fin de travaux en une fois (facture, attestation sur l’honneur, rapport COFRAC,
                        etc.).
                    </p>
                    <p class="text-sm text-black mt-2 font-medium">
                        Si vous rencontrez un problème, n’hésitez pas à contacter votre Account Manager.<br>
                        L’équipe ACE Energie
                    </p>
                </div>
            </div>
        </div>

        <div class="mb-10" *ngIf="selectedMandataire">
            <mat-form-field appearance="outline" class="w-full md:w-1/3">
                <mat-label>Nom du partenaire</mat-label>
                <mat-select [formControl]="partnersCtrl" (selectionChange)="onPartnerSelected($event)">
                    <input class="p-2" matInput placeholder="Rechercher..." #selectPartner>
                    <mat-option *ngFor="let partner of partnersList | filterEntities: selectPartner?.value ?? ''"
                        [value]="partner">
                        {{partner.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <section class="mb-12">
            <h2 class="text-xl font-bold text-gray-800 mb-2">Informations du projet</h2>
            <p class="text-sm text-gray-500 mb-6">
                Ces informations sont facultatives, mais elles facilitent le suivi et l'identification de votre projet.
            </p>

            <div class="bg-white rounded-xl p-2">
                <div class="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm">
                    <form [formGroup]="projectForm" class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-0">

                        <mat-form-field appearance="outline" class="w-ful">
                            <mat-label>Raison sociale du bénéficiaire</mat-label>
                            <input matInput formControlName="rs" class="rounded-md" />
                            <mat-icon matSuffix>business</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Nom du bénéficiaire</mat-label>
                            <input matInput formControlName="nom" />
                            <mat-icon matSuffix>person</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Prénom du bénéficiaire</mat-label>
                            <input matInput formControlName="prenom" />
                            <mat-icon matSuffix>person</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" type="email" />
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Fin des travaux (prévue)</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="dateTravauxPrevisionnelle" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="projectForm.get('dateTravauxPrevisionnelle')?.hasError('required')">
                                Ce champ est obligatoire.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Date d’engagement</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="dateEngagement" />
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="col-span-1 md:col-span-3 w-full">
                            <mat-label>Adresse postale</mat-label>
                            <input formControlName="adresse" matInput [matAutocomplete]="auto"
                                (click)="showAdressAutocomplete()">
                            <mat-icon matSuffix>location_on</mat-icon>
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedOption($event)">
                                <mat-option *ngFor="let option of filteredOptions?.features" [value]="option">
                                    {{option.properties.label}}, France
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Code postal</mat-label>
                            <input matInput formControlName="cp" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Ville</mat-label>
                            <input matInput formControlName="ville" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="tel" />
                            <mat-icon matSuffix>phone</mat-icon>
                        </mat-form-field>
                    </form>
                </div>
            </div>
        </section>

        <section class="mb-12">
            <h2 class="text-xl font-bold text-gray-800 mb-2">Documents</h2>

             <p class="text-sm text-gray-500 mb-6">Veuillez déposer votre devis pour initialiser votre projet.</p>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                <div *ngFor="let card of cards">
                    <app-card-upload [card]="card" (viewFile)="onViewFile($event)"
                        (fileSelected)="onFileSelected($event)">
                    </app-card-upload>
                </div>
            </div>

            <!-- Cards display Section -->
            <div class="w-full flex flex-wrap justify-center gap-4 items-start">
                <div class="w-full flex flex-wrap justify-center gap-4 items-start max-h-[410px] overflow-auto py-2">

                    <!-- Single file cards (up to 3) -->
                    <ng-container *ngIf="getSingleFileCard().length > 0">
                        <app-file-card *ngFor="let file of getSingleFileCard(); let i = index" [cardName]="file.card"
                            [file]="file.files[0]" [fileName]="file.files[0].name"
                            (fileDeleted)="onFileDeleted($event)"></app-file-card>
                    </ng-container>

                    <!-- Multi-file card (4th card slot) -->
                    <ng-container *ngIf="getMultipleFileCard().length > 0">
                        <ng-container *ngFor="let file of getMultipleFileCard()[0].files; let i = index">
                            <app-file-card [cardName]="'Autres justificatifs (CDC, Etude de dimensionnement, etc.)'"
                                [fileName]="file.name" [file]="file"
                                (fileDeleted)="onFileDeleted($event)"></app-file-card>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </section>

        <div class="flex justify-center border-t border-gray-100 pt-8">
            <button (click)="deposeProjectFinancement()"
                [disabled]="projectForm.invalid || isUploadDisabled() || isUploading || (selectedMandataire && !selectedPartnerByMandate)"
                class="bg-[#419a8c] hover:bg-[#357d72] text-white font-bold py-3 px-10 rounded-lg transition-colors shadow-md disabled:opacity-50 inline-flex items-center justify-center">
                <mat-icon svgIcon="send" class="mr-2 !flex items-center justify-center text-white">
                </mat-icon>

                <span>Déposer un devis</span>
            </button>
        </div>

    </div>

    <app-project-display-history [rawItems]="rawItems" [showPartnerName]="!selectedPartnerByMandate">
    </app-project-display-history>
</div>